/* @MCB-TERMS-AND-CONDITIONS */ 
function showCartPopUp() {
  const cartTerms = document.getElementById('mini-cart-terms');
  cartTerms.setAttribute('open', 'true');

  cartTerms.querySelector('.openable__overlay').addEventListener('click', () => {
    cartTerms.removeAttribute('open');
  });

  document.getElementById('mini-cart-terms-btn-decline').addEventListener('click', () => {
    cartTerms.removeAttribute('open');
  });
}

function handleAgreeCheckbox(event) {
  const agreeCheckbox = event.target;
  const checkoutButton = document.querySelector('.checkout-button-wrapper button[type="submit"]');
  const disableOverlay = document.querySelector('#checkout-button-disable');

  if (agreeCheckbox.checked) {
    disableOverlay.style.display = 'none';
    checkoutButton.style.opacity = '1';
  } else {
    disableOverlay.style.display = 'flex';
    checkoutButton.style.opacity = '0';
  }
}

function initializeCartDrawerEvents() {
  const cartDrawer = document.querySelector('.cart-drawer');
  const body = document.body;

  if (cartDrawer) {
    cartDrawer.addEventListener('click', handleCartDrawerClick);
  }

  body.addEventListener('click', handleCheckoutOverlayClick);
}

function handleCartDrawerClick(event) {
  if (event.target.matches('#agree')) {
    handleAgreeCheckbox(event);
  }
}

function handleCheckoutOverlayClick(event) {
  if (event.target && event.target.id === 'checkout-button-disable') {
    if (!document.querySelector('#agree').checked) {
      showCartPopUp();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initializeCartDrawerEvents();
});
